import ApiService from '@/api/service';
import {
  FETCH_NOTIFICATIONS_URL,
  CHANGE_NOTIFICATIONS_READ_STATUS_URL,
  GET_NOT_READ_NOTIFICATIONS_COUNT_URL,
} from '@/api/constants';

export default {
  get(params) {
    return ApiService.query(FETCH_NOTIFICATIONS_URL, params);
  },
  getNotReadCount(params) {
    return ApiService.get(GET_NOT_READ_NOTIFICATIONS_COUNT_URL, params);
  },
  update(params) {
    return ApiService.patch(
      CHANGE_NOTIFICATIONS_READ_STATUS_URL.replace(':id', params), params);
  },
};